/**
 * Permissions from backend
 */
export enum Permission {
  MATCH_DELETE = 'match_delete',
  MATCH_CREATE = 'match_create',
  MATCH_SHOW = 'match_show',
  UPLOAD_REQUEST = 'upload_request',
  VIDEO_SHOW = 'video_show',
  VIDEO_EDIT = 'video_edit',
  VIDEO_DELETE = 'video_delete',
  VIDEO_APPROVE_PENDING = 'video_approve_pending',
  EVENTS_SHOW = 'events_show',
  EVENTS_CREATE = 'events_create',
  EVENTS_EDIT = 'events_edit',
  EVENTS_DELETE = 'events_delete',
  EVENTS_SHOW_SCHEMA = 'events_show_schema',
  EVENTS_EDIT_SCHEMA = 'events_edit_schema',
  PLAYLISTS_SHOW = 'playlists_show',
  PLAYLISTS_CREATE = 'playlists_create',
  PLAYLISTS_EDIT = 'playlists_edit',
  PLAYLISTS_DELETE = 'playlists_delete',
  LIVE_SHOW = 'recorders_show',
  RECORDERS_EDIT_SETTINGS = 'recorders_edit_settings',
  RECORDERS_RECORD = 'recorders_record',
  RECORDERS_LIVE_VIEW = 'recorders_live_view',
  RECORDERS_CONTROL = 'recorders_control',
  RECORDERS_SCHEDULE_SHOW = 'recorders_schedule_show',
  RECORDERS_SCHEDULE_CREATE = 'recorders_schedule_create',
  RECORDERS_SCHEDULE_EDIT = 'recorders_schedule_edit',
  RECORDERS_SCHEDULE_DELETE = 'recorders_schedule_delete',
  PLAYERS_SHOW = 'players_show',
  PLAYERS_CREATE = 'players_create',
  PLAYERS_DELETE = 'players_delete',
  PLAYERS_INVITE = 'players_invite',
  PLAYERS_RESTORE = 'players_restore',
  CLUB_ALBUMS_SHOW = 'club_albums_show',
  CLUB_ALBUMS_CREATE = 'club_albums_create',
  PENDING_VIDEO_SHOW = 'pending_video_show',
  TRACKING_REQUEST_CREATE = 'tracking_request_create'
}

export enum EModulePermissions  {
  SCHEDULING = "scheduling",
  VIDEO_STORAGE = "video_storage"
}
